import Grid from "@mui/material/Grid"
import Tooltip from "@mui/material/Tooltip"
import Typography from "@mui/material/Typography"
import { useTheme } from "@mui/material/styles"

interface Props {
    title: string
    index?: number
    isActive: boolean
    handleSelectObject: (event: React.MouseEvent) => void
}

const ObjectTitle = ({ title, index, isActive, handleSelectObject }: Props) => {
    const theme = useTheme()
    const titleText = title || "..."
    return (
        <Grid
            item
            onMouseDown={(e) => {
                if (e.shiftKey) e.preventDefault()
            }}
            onClick={handleSelectObject}
            sx={{
                width: "auto",
                minWidth: 0,
                overflow: "hidden",
                marginLeft: "10px",
                cursor: "pointer",
                userSelect: "none",
            }}
        >
            <Tooltip title={title}>
                {isActive ? (
                    <Typography variant="body1" color={theme.palette.primary.main} noWrap={true}>
                        {titleText}
                    </Typography>
                ) : (
                    <Typography variant="body1" noWrap={true}>
                        {titleText}
                    </Typography>
                )}
            </Tooltip>
        </Grid>
    )
}

export default ObjectTitle
